<template>
  <vx-card no-shadow title="Nueva Clave">
    <!-- <span>Recuerda no utilizar <strong>caracteres especiales</strong>.</span> -->

    <vs-input class="w-full mb-base" label-placeholder="Descripción" v-model="description"></vs-input>
    <vs-input class="w-full mb-base" label-placeholder="ApiKey/Clave" v-model="secretKey"></vs-input>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="saveChanges">Guardar cambios</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning" @click="cancelChanges">Cancelar</vs-button>
    </div>
  </vx-card>
</template>

<script>
import * as Keychains from './Keychains';
import Security from '@/helpers/security';

export default {
  data () {
    return {
      secretKey: '',
      description: '',
    }
  },
  methods:{
    sendMessageToUpdateList(){
        this.$root.$emit('UPDATE_KEYCHAIN_LIST', {});
    },
    async saveChanges(){
        if((this.description === null) || (this.description === undefined) || (this.description.length <= 0)){
            this.$vs.notify({
                title: 'Gestor de Claves',
                text: `Una descripción te ayudá a recordar que guardaste`,
                color: 'warning',
                icon: 'error',
                time: 4000,
            });
            return false;
        }

        if((this.secretKey === null) || (this.secretKey === undefined) || (this.secretKey.length <= 0)){
            this.$vs.notify({
                title: 'Gestor de Claves',
                text: `Ingresa una api key ó clave válida`,
                color: 'warning',
                icon: 'error',
                time: 4000,
            });
            return false;
        }

        if(this.secretKey.length < 3){
            this.$vs.notify({
                title: 'Gestor de Claves',
                text: `Ingresa una api key ó clave válida (al menos 3 caracteres)`,
                color: 'warning',
                icon: 'error',
                time: 4000,
            });
            return false;
        }

        this.$vs.loading({ type: 'sound' });


        try {
            let data = {
                "description": this.description.trim(),
                "secretKey": Security.utf8_to_b64(this.secretKey.trim()),
            };

            console.info("data:", data);

            await Keychains.saveKey(data);

            this.$vs.notify({
                title: 'Gestor de Claves',
                text: 'Clave guardada con exito!',
                iconPack: 'feather',
                icon: 'icon-bell',
                color: 'primary',
                time: 6000
            });

            this.sendMessageToUpdateList();
            this.cancelChanges();
        } catch (error) {
            console.error("error", error);
            this.$vs.notify({
                title: 'Gestor de Claves',
                text: `Ocurrio un error, al guardar la Clave(${error.message})`,
                color: 'warning',
                icon: 'error',
                time: 6000
            });
        } finally {
            this.$vs.loading.close();
        }
    },
    cancelChanges(){
        this.secretKey = '';
        this.description = '';
    }
  }
}
</script>
